import {
  alphaNum,
  email,
  helpers,
  minLength,
  numeric,
  required,
  requiredIf
} from '@vuelidate/validators'

export const validatorRequired = {
  required: helpers.withMessage('Ce champ est requis.', required)
}

export const validatorRequiredIf = isValid => {
  return {
    required: helpers.withMessage('Ce champ est requis.', requiredIf(isValid))
  }
}

export const validatorMinLength = {
  minLength: helpers.withMessage(
    ({ $params }) =>
      `Ce champ doit avoir un minimum de ${$params.min} caractères.`,
    minLength(5)
  )
}

export const validatorAlphaNum = {
  alphaNum: helpers.withMessage(
    'Ce champ ne doit contenir que des caractères alphanumériques.',
    alphaNum
  )
}

export const validatorEmail = {
  email: helpers.withMessage('Ce champ doit être au format E-mail.', email)
}

export const validatorNumeric = {
  numeric: helpers.withMessage(
    'Ce champ ne doit contenir que des chiffres.',
    numeric
  )
}
